export default {
  FILTERS: 'FILTERS',
  SEARCH: 'SEARCH'
};
